import { useState, useEffect } from 'react'

export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(window.matchMedia(query).matches)

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query)
        const documentChangeHandler = () => setMatches(mediaQueryList.matches)

        mediaQueryList.addEventListener('change', documentChangeHandler)
        return () => mediaQueryList.removeEventListener('change', documentChangeHandler)
    }, [query])

    return matches
}